

import LookupCard from './lookup-card';
import { WDFormat } from 'wd';

/**
  Events:
  kiosks:selected -> when an kiosk is picked, it passes the kiosk back to the caller
  */

export default class VendorLookupCard extends LookupCard
{
  constructor()
  {
    super({ title: 'Vendors' });
  };

  get fetchURI()
  {
    return `/lookup/companies/${this.company.value}/vendors`;
  }

  get listConfig()
  {
    return {
      columns: [
        { label: 'Vendor', value: 'name', sort:true },
        { label: 'Code', value:'code' },
        { label: 'Last Activity', value:'last_activity',format:WDFormat.date}
      ],
      //fetch: this.fetchApi,
      valueField: 'id',
      focusable: true,
      method: 'post',
      options: [],
      //click: (item, row) => {},
      filters: [
        { type: 'text', name: 'search_string', placeholder: 'Search Vendors', static: true },
      ],
      buttons: [
        {
          fasIcon: 'file-invoice-dollar',
          title: 'View Transactions',
          click: (data) => this.viewTransactions(data),
        }
      ]
    };

  };

  handleSelected(evt)
  {
    this.triggerHammer(evt,evt.detail.model.code);
  }

  viewTransactions(data) 
  {
    //evt.stopPropagation();
    //evt.preventDefault();

    const tc = this.cardList.querySelector('transactions-card');
    tc.searchString = data.code + ' INV:';
    this.cardList.showCard('wd-card-transactions');
  };

}

customElements.define('vendor-lookup-card',VendorLookupCard);

